<template>
  <div class="row">
    <div class="col-12 form-group form-group-sm">
      <div class="container">
        <div class="row">
          <template>
            <div class="col-12 form-group form-group-sm">
              <label class="label" for="empresaPropia"
                >Empresa Propia Facturadora</label
              >
              <SelectorEmpresaPropia
                v-model="empresaPropia"
                @ready="empresaPropiaReady"
                :clienteId="clienteId"
                :disabled="disabled"
              />
            </div>
          </template>
          <template v-if="mostrarEmpresaDelCliente">
            <div
              class="col-12 col-md-6 form-group form-group-sm"
              v-show="inicializado"
            >
              <label class="label" for="empresa">Empresa del Cliente</label>
              <multiselect-item
                id="empresa"
                v-model="empresa"
                :options="empresaOptions"
                placeholder="Seleccione un empresa"
                track-by="id_empresa"
                :show-label="false"
                :selectLabel="''"
                deselectLabel=""
                :disabled="disabled"
              >
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                    <span class="option__title"
                      >{{ props.option.RazonSocial }}
                      {{
                        props.option.CUIT ? ` - CUIT: ${props.option.CUIT}` : ""
                      }}</span
                    ><br />
                    <span class="option__small">
                      {{ props.option.contratos_por_empresa }} contratos
                    </span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.RazonSocial
                    }}</span
                    ><br />
                    <span class="option__small">
                      {{ props.option.contratos_por_empresa }} contratos
                    </span>
                  </div>
                </template>
              </multiselect-item>
            </div>
            <div class="col-12" v-show="!inicializado">Cargando ...</div>
            <div
              v-if="empresa && !isNumber(empresa)"
              class="col-12 col-md-6 form-group form-group-sm"
            >
              <label class="label" for="subfactura">Subfactura</label>
              <multiselect-item
                id="subfactura"
                v-model="subfactura"
                :custom-label="
                  (subf) => `${subf.subfactura} - ${subf.contratos} contratos `
                "
                :options="empresa.subfacturas"
                placeholder="Elija subfactura"
                track-by="subfactura"
                :show-label="false"
                :disabled="disabled"
              >
              </multiselect-item>
            </div>
          </template>
          <template v-else>
            <small
              >El contrato es sin factura,según la opción seleccionada
            </small>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, isNil, isNumber } from "lodash-es";
import SelectorEmpresaPropia from "../../../Clientes/shared/SelectorEmpresaPropia.vue";
import adaptarVueModel from "../../shared/AdaptarVueModel";
import axios from "axios";

export default {
  name: "EmpreasFacturacionForm",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { SelectorEmpresaPropia },
  mixins: [adaptarVueModel],
  data: () => ({
    empresaOptions: [],
    inicializado: false,
  }),
  methods: {
    isNumber: isNumber,
    empresaPropiaLabel(empresa) {
      return empresa.nombre;
    },
    async empresaPropiaReady() {
      this.inicializado = false;
      this.getEmpresas().then(() => {
        this.$emit("hayEmpresas", !!this.empresaOptions.length);
      });
    },
    async getEmpresas() {
      this.inicializado = false;
      const { data } = await axios.post("/execute", {
        method: "CLI.GetEmpresasSimplesWithSubfacturasByClienteId",
        parameters: [
          {
            name: "id_cliente",
            value: this.$route.params.id_cliente,
          },
        ],
      });

      if (!data.ok) {
        this.$msgBoxOk(data.message);
        return;
      }

      const empresas = get(data, "result[0]", []);

      const empresaOptions = empresas.reduce((carry, curr) => {
        if (carry.length === 0) {
          const empresa = { ...curr };
          empresa.subfacturas = [
            { subfactura: curr.subfactura, contratos: curr.contratos },
          ];
          return [empresa];
        }

        let empresaIndex = carry.findIndex(
          (e) => e.id_empresa === curr.id_empresa,
        );

        if (empresaIndex === -1) {
          const empresa = { ...curr };
          empresa.subfacturas = [
            { subfactura: curr.subfactura, contratos: curr.contratos },
          ];
          return [...carry, empresa];
        } else {
          carry[empresaIndex].subfacturas.push({
            subfactura: curr.subfactura,
            contratos: curr.contratos,
          });
          return carry;
        }
      }, []);

      this.empresaOptions = empresaOptions.map((e) => {
        const mayorSubfactura = e.subfacturas.sort(
          (subfA, subfB) => subfA.subfactura - subfB.subfactura,
        )[e.subfacturas.length - 1];
        e.subfacturas.push({
          subfactura: mayorSubfactura.subfactura + 1,
          contratos: 0,
        });
        return e;
      });

      // adapto empresa
      if (isNumber(this.empresa) && this.empresa > 0) {
        this.empresa = this.empresaOptions.find(
          (el) => get(el, `id_empresa`, null) === this.empresa,
        );
      }
      // adapto subfactura
      if (isNumber(this.subfactura) && !isNil(this.empresa)) {
        this.subfactura = this.empresa.subfacturas.find(
          (el) => get(el, `subfactura`, null) === this.subfactura,
        );
      }

      if (this.empresaOptions.length === 0) {
        this.mostrarFormulario = false;
      }

      this.inicializado = true;
    },
  },
  computed: {
    clienteId() {
      return this.$route.params.id_cliente;
    },
    mostrarEmpresaDelCliente() {
      return get(this.empresaPropia, "id_empresas_propias", 0) !== 0;
    },
    empresa: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.empresa;
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setEmpresa", val);
        if (this.inicializado) {
          this.$store.commit("Contratos/ModificarContrato/setSubfactura", null);
        }
      },
    },
    subfactura: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.subfactura;
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setSubfactura", val);
      },
    },
    empresaPropia: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.empresaPropia;
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setEmpresaPropia", val);
        if (this.inicializado) {
          this.$store.commit("Contratos/ModificarContrato/setEmpresa", null);
          this.$store.commit("Contratos/ModificarContrato/setSubfactura", null);
        }
      },
    },
  },
};
</script>

<style scoped></style>
